import type { CustomerOrderItem } from '../../../types/customer';

/** How many orders the Overview tab's recent-orders block shows. */
export const RECENT_ORDERS_LIMIT = 5;

/**
 * Pick the most recent orders for the Overview block.
 *
 * Reuses the orders the profile already carries (the same list the Orders tab
 * renders), so the block costs no extra request. Newest first by created_at;
 * an unparseable date sorts last so a bad row never hides a good one.
 */
export function selectRecentOrders(
  orders: readonly CustomerOrderItem[],
  limit: number = RECENT_ORDERS_LIMIT,
): CustomerOrderItem[] {
  const ts = (o: CustomerOrderItem): number => {
    const t = Date.parse(o.created_at);
    return Number.isNaN(t) ? Number.NEGATIVE_INFINITY : t;
  };
  return [...orders].sort((a, b) => ts(b) - ts(a)).slice(0, Math.max(0, limit));
}
